import { render, staticRenderFns } from "./CarouselSample.vue?vue&type=template&id=38456b88&"
import script from "./CarouselSample.vue?vue&type=script&lang=js&"
export * from "./CarouselSample.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports